import { Doc } from "../../../_generated/dataModel";
import { FilterRule, FilterRuleCtx } from "../../../lib/types/filters_types";

// Filtra vendedores por estado interno (active/deleted).
export const sellersInternalControlStateRule: FilterRule<Doc<"sellers">> = {
  priority: 6,
  build: async (ctx: FilterRuleCtx, args: Partial<Omit<Doc<"sellers">, "_id" | "_creationTime">>) => {
    const { userContext } = ctx;
    const state = args.internalControl?.state;

    if (!state) return undefined;

    if (!userContext?.companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    const sellers = await ctx.db
      .query("sellers")
      .withIndex("by_company_id", (q) =>
        q.eq("internalControl.companyId", userContext.companyId!),
      )
      .collect();

    return sellers.filter(
      (seller) => seller?.internalControl?.state === state,
    );
  },
};
